module.exports = __webpack_public_path__ + "static/media/ibd_neck3.6c4772d5.png";